import React from 'react';
import { useLocale } from '../contexts/LocaleContext';
import type { PostContext } from '../types';

/**
 * The journey context strip that makes a Beelyv post more than a photo:
 * category, streak and achievement, in the brand's overline treatment.
 */
export function ActivityContext({
  context,
  tone = 'light'
}: {
  context: PostContext;
  tone?: 'light' | 'dark';
}) {
  const {
    t,
    tl
  } = useLocale();
  const parts: string[] = [t(`category.${context.category}`)];
  if (context.streak) parts.push(t('post.streak', {
    n: context.streak
  }));
  if (context.achievement) parts.push(tl(context.achievement));
  if (context.xp) parts.push(`+${context.xp} ${t('common.xp')}`);
  return <p className={`bee-overline text-[9px] font-bold ${tone === 'dark' ? 'text-gold' : 'text-gold-deep'}`} data-id="element-216" data-mp="1hryb63u55hog">
      {parts.join(' · ')}
    </p>;
}